import React from 'react';
import classes from './index.module.scss';
import ReactPlayer from 'react-player';
import { ReactComponent as PlayIcon } from '../../../assets/icons/play.svg';

const Video = ({ preview, startPlayerHandler, visibility, name, link, title }) => {
  return (
    <div className={classes.React_Player_Wrap}>
      <ReactPlayer 
        url={link} 
        className={classes.Player}
        light={preview}
        playing
        width="100%"
        onClickPreview={() => startPlayerHandler(name)}
        playIcon={<PlayIcon />}
      />
      <div className={`${visibility ? classes.Blur : classes.Hide}`}></div>
      <h3 className={`${visibility ? classes.Player_Preview_Title : classes.Hide}`}>
        {title}
      </h3>
    </div>
  )
}

export default Video;